var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.197 4.39296H15.0299C16.2212 4.39296 17 5.41602 17 6.86987V8.91602H3V6.86987C3 5.46987 3.91636 4.39296 5.10771 4.39296H6.94056V2.77757C6.94056 2.23911 7.21554 1.91602 7.67375 1.91602C8.13196 1.91602 8.40693 2.3468 8.40693 2.77757V4.39296H11.7307V2.77757C11.7307 2.23911 12.0056 1.91602 12.4639 1.91602C12.9221 1.91602 13.197 2.3468 13.197 2.77757V4.39296ZM5.20621 17.0827C4.01127 17.0827 3 16.3684 3 15.4398L3.00024 10.0827H17V15.4398C17 16.3684 16.0809 17.0827 14.8859 17.0827H5.20621Z",
    fill: "#4D55E5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIconBlue);
export default __webpack_public_path__ + "static/media/calendar-icon-blue.f60afb18efde455a03eda4adf1eea940.svg";
export { ForwardRef as ReactComponent };